export default [
    {
        date: 1518741095041,
        row: 20,
        col: 22,
        squares: [
            [20, 20, "#000000"],
            [19, 20, "#000000"],
            [17, 20, "#000000"],
            [18, 20, "#000000"],
            [16, 20, "#000000"],
            [15, 20, "#000000"],
            [14, 20, "#000000"],
            [13, 20, "#000000"],
            [13, 19, "#000000"],
            [13, 18, "#000000"],
            [13, 17, "#000000"],
            [13, 16, "#000000"],
            [13, 15, "#000000"],
            [13, 14, "#000000"],
            [14, 14, "#000000"],
            [16, 14, "#000000"],
            [15, 14, "#000000"],
            [17, 14, "#000000"],
            [18, 14, "#000000"],
            [19, 14, "#000000"],
            [20, 14, "#000000"],
            [17, 19, "#000000"],
            [17, 18, "#000000"],
            [17, 17, "#000000"],
            [18, 17, "#000000"],
            [19, 17, "#000000"],
            [20, 17, "#000000"],
            [20, 19, "#000000"],
            [19, 19, "#000000"],
            [18, 19, "#000000"],
            [18, 18, "#000000"],
            [20, 18, "#000000"],
            [19, 18, "#A61C00"],
            [14, 18, "#00FF00"],
            [15, 18, "#00FF00"],
            [15, 19, "#00FF00"],
            [14, 19, "#00FF00"],
            [16, 19, "#00FF00"],
            [16, 18, "#00FF00"],
            [16, 15, "#00FF00"],
            [16, 16, "#00FF00"],
            [16, 17, "#00FF00"],
            [15, 17, "#00FF00"],
            [14, 17, "#00FF00"],
            [14, 16, "#00FF00"],
            [14, 15, "#00FF00"],
            [15, 15, "#00FF00"],
            [15, 16, "#00FF00"],
            [17, 15, "#FF00FF"],
            [17, 16, "#FF00FF"],
            [18, 16, "#FF00FF"],
            [19, 15, "#FF00FF"],
            [20, 16, "#FF00FF"],
            [18, 15, "#FF00FF"],
            [20, 15, "#FF00FF"],
            [19, 16, "#FF00FF"],
            [12, 20, "#000000"],
            [10, 20, "#000000"],
            [11, 20, "#000000"],
            [9, 20, "#000000"],
            [8, 20, "#000000"],
            [7, 20, "#000000"],
            [7, 19, "#000000"],
            [10, 19, "#000000"],
            [11, 19, "#000000"],
            [12, 19, "#000000"],
            [8, 19, "#000000"],
            [9, 19, "#000000"],
            [6, 20, "#000000"],
            [5, 21, "#000000"],
            [4, 21, "#000000"],
            [3, 20, "#000000"],
            [3, 19, "#000000"],
            [3, 18, "#000000"],
            [4, 17, "#000000"],
            [5, 17, "#000000"],
            [6, 18, "#000000"],
            [6, 19, "#000000"],
            [5, 19, "#D9D9D9"],
            [4, 19, "#D9D9D9"],
            [4, 20, "#D9D9D9"],
            [5, 20, "#D9D9D9"],
            [5, 18, "#D9D9D9"],
            [4, 18, "#D9D9D9"],
            [1, 22, "#0000FF"],
            [1, 21, "#0000FF"],
            [1, 19, "#0000FF"],
            [1, 17, "#0000FF"],
            [1, 10, "#0000FF"],
            [1, 2, "#0000FF"],
            [1, 1, "#0000FF"],
            [1, 3, "#0000FF"],
            [1, 5, "#0000FF"],
            [1, 4, "#0000FF"],
            [1, 6, "#0000FF"],
            [1, 7, "#0000FF"],
            [1, 9, "#0000FF"],
            [1, 8, "#0000FF"],
            [1, 11, "#0000FF"],
            [1, 12, "#0000FF"],
            [1, 13, "#0000FF"],
            [1, 15, "#0000FF"],
            [1, 14, "#0000FF"],
            [1, 16, "#0000FF"],
            [1, 20, "#0000FF"],
            [1, 18, "#0000FF"],
            [2, 22, "#0000FF"],
            [2, 20, "#0000FF"],
            [2, 19, "#0000FF"],
            [2, 21, "#0000FF"],
            [2, 18, "#0000FF"],
            [2, 17, "#0000FF"],
            [2, 1, "#0000FF"],
            [2, 2, "#0000FF"],
            [2, 4, "#0000FF"],
            [2, 3, "#0000FF"],
            [2, 5, "#0000FF"],
            [2, 6, "#0000FF"],
            [2, 11, "#0000FF"],
            [2, 9, "#0000FF"],
            [2, 13, "#0000FF"],
            [2, 7, "#0000FF"],
            [2, 16, "#0000FF"],
            [2, 10, "#0000FF"],
            [2, 8, "#0000FF"],
            [2, 12, "#0000FF"],
            [2, 14, "#0000FF"],
            [2, 15, "#0000FF"],
            [20, 22, "#00FF00"],
            [20, 21, "#00FF00"],
            [20, 13, "#00FF00"],
            [20, 11, "#00FF00"],
            [20, 12, "#00FF00"],
            [20, 9, "#00FF00"],
            [20, 10, "#00FF00"],
            [20, 8, "#00FF00"],
            [20, 7, "#00FF00"],
            [20, 6, "#00FF00"],
            [20, 5, "#00FF00"],
            [20, 4, "#00FF00"],
            [20, 2, "#00FF00"],
            [20, 3, "#00FF00"],
            [20, 1, "#00FF00"],
            [19, 9, "#00FF00"],
            [18, 9, "#00FF00"],
            [17, 9, "#00FF00"],
            [16, 10, "#FF00FF"],
            [15, 11, "#FF00FF"],
            [14, 10, "#FF00FF"],
            [14, 9, "#FF00FF"],
            [14, 8, "#FF00FF"],
            [15, 7, "#FF00FF"],
            [16, 8, "#FF00FF"],
            [15, 8, "#FF00FF"],
            [15, 9, "#FF00FF"],
            [15, 10, "#FF00FF"],
            [16, 9, "#FF00FF"],
            [19, 5, "#5CB85C"],
            [19, 4, "#5CB85C"],
            [18, 5, "#5CB85C"],
            [18, 4, "#5CB85C"],
            [17, 4, "#5CB85C"],
            [17, 5, "#5CB85C"],
            [16, 4, "#5CB85C"],
            [16, 5, "#5CB85C"],
            [15, 4, "#5CB85C"],
            [15, 5, "#5CB85C"],
            [14, 4, "#5CB85C"],
            [14, 5, "#5CB85C"],
            [13, 4, "#5CB85C"],
            [13, 5, "#5CB85C"],
            [12, 5, "#5CB85C"],
            [12, 4, "#5CB85C"],
            [11, 5, "#5CB85C"],
            [10, 6, "#5CB85C"],
            [9, 7, "#5CB85C"],
            [8, 8, "#5CB85C"],
            [7, 9, "#5CB85C"],
            [6, 9, "#5CB85C"],
            [5, 10, "#5CB85C"],
            [5, 9, "#5CB85C"],
            [5, 8, "#5CB85C"],
            [5, 7, "#5CB85C"],
            [5, 6, "#5CB85C"],
            [5, 5, "#5CB85C"],
            [5, 4, "#5CB85C"],
            [5, 3, "#5CB85C"],
            [5, 2, "#5CB85C"],
            [6, 2, "#5CB85C"],
            [8, 3, "#5CB85C"],
            [9, 3, "#5CB85C"],
            [10, 4, "#5CB85C"],
            [11, 4, "#5CB85C"],
            [10, 3, "#5CB85C"],
            [7, 2, "#5CB85C"],
            [6, 8, "#5CB85C"],
            [7, 4, "#A61C00"],
            [9, 5, "#A61C00"],
            [7, 7, "#A61C00"],
            [6, 6, "#A61C00"],
            [8, 6, "#A61C00"],
            [7, 8, "#5CB85C"],
            [6, 7, "#5CB85C"],
            [7, 6, "#5CB85C"],
            [7, 5, "#5CB85C"],
            [8, 5, "#5CB85C"],
            [8, 4, "#5CB85C"],
            [9, 4, "#5CB85C"],
            [10, 5, "#5CB85C"],
            [9, 6, "#5CB85C"],
            [8, 7, "#5CB85C"],
            [6, 3, "#5CB85C"],
            [7, 3, "#5CB85C"],
            [6, 4, "#5CB85C"],
            [6, 5, "#5CB85C"],
            [5, 1, "#5CB85C"],
            [4, 8, "#5CB85C"],
            [3, 7, "#5CB85C"],
            [3, 6, "#5CB85C"],
            [3, 5, "#5CB85C"],
            [3, 4, "#5CB85C"],
            [3, 3, "#5CB85C"],
            [4, 2, "#5CB85C"],
            [4, 4, "#5CB85C"],
            [4, 5, "#5CB85C"],
            [4, 3, "#5CB85C"],
            [4, 6, "#5CB85C"],
            [4, 7, "#5CB85C"],
            [12, 18, "#FF00FF"],
            [11, 17, "#FF00FF"],
            [10, 16, "#FF00FF"],
            [9, 15, "#FF00FF"],
            [9, 14, "#FF00FF"],
            [10, 14, "#FF00FF"],
            [11, 14, "#FF00FF"],
            [12, 14, "#FF00FF"],
            [12, 17, "#FF00FF"],
            [12, 16, "#FF00FF"],
            [12, 15, "#FF00FF"],
            [11, 15, "#FF00FF"],
            [10, 15, "#FF00FF"],
            [11, 16, "#FF00FF"],
            [10, 18, "#FF00FF"],
            [11, 18, "#FF00FF"],
            [10, 17, "#FF00FF"],
            [9, 16, "#FF00FF"],
            [9, 17, "#FF00FF"],
            [9, 18, "#FF00FF"],
            [8, 13, "#FF00FF"],
            [7, 12, "#FF00FF"],
            [6, 13, "#FF00FF"],
            [5, 14, "#FF00FF"],
            [6, 16, "#FF00FF"],
            [5, 15, "#FF00FF"],
            [6, 17, "#FF00FF"],
            [7, 18, "#FF00FF"],
            [8, 18, "#FF00FF"],
            [7, 16, "#FF00FF"],
            [7, 14, "#FF00FF"],
            [6, 15, "#FF00FF"],
            [7, 15, "#FF00FF"],
            [6, 14, "#FF00FF"],
            [7, 13, "#FF00FF"],
            [7, 17, "#FF00FF"],
            [8, 17, "#FF00FF"],
            [8, 14, "#FF00FF"],
            [8, 15, "#FF00FF"],
            [8, 16, "#FF00FF"],
            [8, 12, "#FF00FF"],
            [6, 12, "#FF00FF"],
            [5, 12, "#FF00FF"],
            [5, 13, "#FF00FF"],
            [9, 12, "#FF00FF"],
            [10, 12, "#FF00FF"],
            [12, 12, "#FF00FF"],
            [11, 12, "#FF00FF"],
            [12, 13, "#FF00FF"],
            [11, 13, "#FF00FF"],
            [9, 13, "#FF00FF"],
            [10, 13, "#FF00FF"],
            [5, 16, "#FF00FF"],
        ],
    },
];
